import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { Borders, Colors, Space, BorderWidths } from '../../types';

export const Divider: ComponentStyleConfig = {
  baseStyle: props => ({
    borderBottomWidth: BorderWidths.SM,
    opacity: '1',
    borderColor: Colors.BORDER_DEFAULT,
    borderStyle: 'solid',
    marginX: props.orientation === 'vertical' ? Space.SM : '',
    marginY: props.orientation === 'vertical' ? '' : Space.SM,
  }),
  variants: {
    sm: props => ({
      borderBottomWidth: props.orientation === 'vertical' ? '' : BorderWidths.XS,
      borderLeftWidth: props.orientation === 'vertical' ? BorderWidths.XS : '',
    }),

    md: props => ({
      borderBottomWidth: props.orientation === 'vertical' ? '' : BorderWidths.SM,
      borderLeftWidth: props.orientation === 'vertical' ? BorderWidths.SM : '',
    }),

    lg: props => ({
      borderBottomWidth: props.orientation === 'vertical' ? '' : BorderWidths.LG,
      borderLeftWidth: props.orientation === 'vertical' ? BorderWidths.LG : '',
    }),

    dashed: {
      borderStyle: Borders.DASHED,
      borderBottomWidth: BorderWidths.XS,
    },

    borderDefault: props => ({
      borderColor: Colors.BORDER_DEFAULT,
      borderBottomWidth: props.orientation === 'vertical' ? '' : BorderWidths.SM,
      borderLeftWidth: props.orientation === 'vertical' ? BorderWidths.SM : '',
    }),
  },
  sizes: {},
};
